import type { useSingleton } from "@tippyjs/react";
import { useAtomValue } from "jotai";
import { useTranslation } from "react-i18next";
import { canv } from "@/canv/global";
import { MinusIcon, PlusIcon } from "@/icons";
import { zoomAtom } from "@/interface/AppStore";
import { Tooltip } from "@/interface/ui/Tooltip";
import { BottomBarItem } from "../BottomBarItem";
import styles from "./ZoomControls.module.css";

export const ZoomControls = ({
    singletonTarget,
}: {
    singletonTarget: ReturnType<typeof useSingleton>[1];
}) => {
    const { t } = useTranslation();
    const zoom = useAtomValue(zoomAtom);
    const handleMinus = () => {
        canv.actionManager.zoomMinus();
    };
    const handlePlus = () => {
        canv.actionManager.zoomPlus();
    };
    return (
        <>
            <Tooltip
                content={t("bottomBar.zoomOut")}
                hotkey={`${canv.actionManager.actionSymbol} -`}
                singleton={singletonTarget}
            >
                <BottomBarItem onClick={handleMinus}>
                    <MinusIcon />
                </BottomBarItem>
            </Tooltip>
            <Tooltip content={t("bottomBar.zoom")} singleton={singletonTarget}>
                <BottomBarItem className={styles.zoomValue} as="span">
                    {zoom}%
                </BottomBarItem>
            </Tooltip>
            <Tooltip
                content={t("bottomBar.zoomIn")}
                hotkey={`${canv.actionManager.actionSymbol} +`}
                singleton={singletonTarget}
            >
                <BottomBarItem onClick={handlePlus}>
                    <PlusIcon />
                </BottomBarItem>
            </Tooltip>
        </>
    );
};
